import { Button } from '../Button';
import { buttonColor, buttonSize } from '../ButtonTypes';

type BottomSubmitBlockType = {
  onCancelForm: () => void;
  submitText: string;
  cancelText: string;
  isDisabledSubmit?: boolean;
  isDisabledCancel?: boolean;
};

export const BottomSubmitBlock: React.FC<BottomSubmitBlockType> = ({
  onCancelForm,
  submitText,
  cancelText,
  isDisabledSubmit = false,
  isDisabledCancel = false,
}) => (
  <div key="bottom-submit-block" className="row">
    <div className="col-xs-12">
      <div className="pull-right">
        <Button
          type="submit"
          className="margin-right submit"
          disabled={isDisabledSubmit}
          color={buttonColor.success}
          size={buttonSize.small}
        >
          {submitText}
        </Button>
        <Button
          type="button"
          className="cancel"
          onClick={onCancelForm}
          disabled={isDisabledCancel}
          color={buttonColor.default}
          size={buttonSize.small}
        >
          {cancelText}
        </Button>
      </div>
    </div>
  </div>
);
